var exports = {
  "k": "xcc377c0b--c1566b--container",
  "h": "xcc377c0b--c1566b--counter",
};

module.exports = exports;
